import { useState, useEffect } from 'react';

export const useNetworkStatus = () => {
  const [status, setStatus] = useState({
    ethereum: { online: true, loading: false }, // Assume online by default
    snapshot: { online: true, loading: false },
    ipfs: { online: true, loading: false },
    ens: { online: true, loading: false }
  });

  useEffect(() => {
    // Simple connectivity check using native browser fetch
    const checkConnectivity = async (url, service) => {
      try {
        // Use HEAD request to minimize data transfer
        const response = await fetch(url, { 
          method: 'HEAD',
          mode: 'no-cors', // Avoid CORS issues
          cache: 'no-cache'
        });
        
        // If we get here, the service is reachable
        setStatus(prev => ({
          ...prev,
          [service]: { online: true, loading: false }
        }));
      } catch (error) {
        // If HEAD fails, try a simple image load
        const img = new Image();
        img.onload = () => {
          setStatus(prev => ({
            ...prev,
            [service]: { online: true, loading: false }
          }));
        };
        img.onerror = () => {
          setStatus(prev => ({
            ...prev,
            [service]: { online: false, loading: false, error: 'Service unreachable' }
          }));
        };
        
        // Use favicon or a known reliable endpoint
        if (service === 'ethereum') {
          img.src = 'https://etherscan.io/favicon.ico?' + Date.now();
        } else if (service === 'snapshot') {
          img.src = 'https://snapshot.org/favicon.ico?' + Date.now();
        } else if (service === 'ipfs') {
          img.src = 'https://ipfs.io/favicon.ico?' + Date.now();
        } else if (service === 'ens') {
          img.src = 'https://app.ens.domains/favicon.ico?' + Date.now();
        }
      }
    };

    // Check all services
    checkConnectivity('https://etherscan.io', 'ethereum');
    checkConnectivity('https://snapshot.org', 'snapshot');
    checkConnectivity('https://ipfs.io', 'ipfs');
    checkConnectivity('https://app.ens.domains', 'ens');

    // Refresh status every 5 minutes (less frequent to avoid rate limits)
    const interval = setInterval(() => {
      checkConnectivity('https://etherscan.io', 'ethereum');
      checkConnectivity('https://snapshot.org', 'snapshot');
      checkConnectivity('https://ipfs.io', 'ipfs');
      checkConnectivity('https://app.ens.domains', 'ens');
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return status;
};